import React, { useState, useEffect, useRef } from 'react';
import style from './PayMedicalExpenses.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import TotalMedicalPaidDetailBox from '../../../../components/box/TotalMedicalPaidDetailBox';
import URL from '../../../../constants/url';
import { Link, useNavigate } from 'react-router-dom';
import imgCalculating from '../../../../images/user/i_calculating.svg';


const MedicalOutDetails = () => {

    const navigate = useNavigate();

    
    return (
        <>
            <HeadSub title="진료비 수납" />

            <div id="sub-content" data-layout="white">     
                <div className='inner-wrap' data-pad-type="a-1">
                    
                   {/* 수납금액이 산정 안됬을때 */}
                   {/* <div className={style['mid-box']}>
                        <div className='animation-2'>
                            <div className={style['mid']}>
                                <object data={imgCalculating} alt="" />
                            </div>
                            <div className={style['botm']}>
                                <strong>아직 수납 금액이 산정되지 않았습니다.</strong>
                                <span>해당 진료 종료 후 00분 ~ 00분정도 소요됩니다.</span>
                            </div>
                        </div>
                    </div> */}

                   
                    {/* 수납금액이 산정 됬을때 */}
                    <>
                        <div className={style['cont-box']}>
                            <TotalMedicalPaidDetailBox type="normal"/>
                        </div>

                        
                        <div className={style["bottom-fixed-box"]}>
                            <div className={style["inner-box"]}>

                                <div className={style['notice-txts']}>
                                    <p>수납금액</p>
                                    <p>21,000원</p>
                                </div>
                                <div className={style['btn-layout']}> 
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg">
                                        <span>결제하기</span>
                                    </button>
                                </div>
                                
                            </div>
                        </div>       
                    </>        
                    

                </div>
            </div>
            
        </>
    );
};

export default MedicalOutDetails;
